import { generators, converters } from "@/_shared/utils";

export const useImageField = {
  data() {
    return {
      image: {
        name: null,
        content: null,
      },
      imageFile: null,
      previewImage: null,
    };
  },
  methods: {
    checkPreviewImageExistence() {
      this.previewImage = this.form.image_url;
    },
    setImage(file) {
      this.imageFile = file;
      this.previewImage = URL.createObjectURL(file);

      const uniqueSalt = generators.generateRandomString(24);
      this.image.name = `${uniqueSalt}-${this.imageFile.name}`;
      this.form.image_url = null;
    },
    deleteImage() {
      this.previewImage = null;
      this.imageFile = null;
      this.image.name = null;
      this.form.image_url = null;
    },
    async encodeImage(imageIsRequired = true) {
      if (!this.image.name && imageIsRequired && !this.form.image_url) {
        throw new Error('Вы не добавили изображения для этой записи');
      }
      if (this.imageFile !== null) {
        const encodedImage = await converters.toBase64(this.imageFile);
        this.image.content = encodedImage;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useImageField.js